import { SectionWrapper } from '../../../../components/ui/SectionWrapper';
import { useLanguage } from '../../../../context/LanguageContext';
import { certificationsService } from '../../../../services/certifications.service';
import { publicationsService } from '../../../../services/publications.service';
import { talksService } from '../../../../services/talks.service';
import { workExperiencesService } from '../../../../services/work-experiences.service';

const STATS = [
    { key: 'about.stats.roles', value: workExperiencesService.getWorkExperiences().length },
    { key: 'about.stats.certifications', value: certificationsService.getCertifications().length },
    { key: 'about.stats.talks', value: talksService.getTalks().length },
    { key: 'about.stats.publications', value: publicationsService.getPublications().length },
];

export function AboutSection() {
    const { t } = useLanguage();

    return (
        <SectionWrapper id="about" title={t('section.about')} alternate>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                <div className="md:col-span-2">
                    <p className="text-lg text-slate-600 dark:text-slate-300 leading-relaxed">
                        {t('about.description')}
                    </p>
                </div>

                <div className="grid grid-cols-2 gap-4">
                    {STATS.map(stat => (
                        <div key={stat.key} className="text-center p-4 bg-white dark:bg-slate-800 rounded-xl shadow-sm ring-1 ring-slate-900/5 dark:ring-slate-700/50">
                            <div className="text-2xl font-bold text-blue-600 dark:text-blue-400">{stat.value}</div>
                            <div className="text-sm text-slate-500 dark:text-slate-400 mt-1">{t(stat.key)}</div>
                        </div>
                    ))}
                </div>
            </div>
        </SectionWrapper>
    );
}
